<script>
import i18n from "../i18n";

/**
 * Browse File component
 */
export default {
  components: {
    
  },
  data() {
    return {
    };
  },
  mounted() {
    // i18n.locale = localStorage.getItem('locale');
  },
  methods: {
    visibleLoading: function() {
      return this.requesting;
    },
    visbleIcon: function () {
      return this.icon !== '' && this.requesting ? false : true;
    },
    translate: function(name) {
      return i18n.t(name);
    }
  },
  computed: {
    
  },
  props: {
    type: {
      type: String,
      default: 'text',
    }, 
    id: {
      type: String,
    },
    label: {
      type: String,
      default: ''
    },
    model: null,
    disabled: {
      default: false
    }
  },
};
</script>
<template>
  <div class="form-group">

    <b-form-group
      class="mb-3"
      :label="$t(label)"
      :label-for="id"
    > 
      <input 
        class="form-control" 
        :value='model'
        :disabled="disabled"
        @input='$emit("update:model", $event)'
        :type="type" 
        :id="id" />
    </b-form-group>
  </div>
</template>